<!-- eslint-disable -->
<template lang="pug">
    .image-container(:style="sizes")
        template(v-if="!isAnswerTurtle")
            img.image-container__phrase(
                ref="phraseContainer",
                :src="phrase",
                alt="phrase",
                :class="{'image-container__phrase--with-gap': !isMultiplayer}",
                :style="cosmoWidth"
                @load="setNewHeight"
            )
            img.image-container__turtle(
                v-if="!isMultiplayer",
                ref="turtleContainer",
                :src="turtle",
                alt="clevik"
            )
        template(v-else)
            img.image-container__turtle(:src="answerTurtle", alt="clevik", @load="setNewHeight")
</template>
<script>
    /*eslint-disable*/
    const TURTLE_IMAGES = {
        success: 'SuccessTurtle',
        failure: 'FailureTurtle',
    };
    const IMAGES_AMOUNT = {
        success: 7,
        failure: 8,
    };
    const AVAILABLE_PHRASES_DIRS = ['ru', 'fr', 'uk', 'lv'];
    const AVAILABLE_ANSWERS_DIRS = ['ru', 'fr'];
    import { mapState } from 'vuex';
    export default {
        props: {
            status: {
                type: String,
                default: 'success',
            },
            isMultiplayer: {
                type: Boolean,
                default: false,
            },
            isAnswerTurtle: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            sizes() {
                return !this.isMultiplayer
                    ? { height: this.containerHeight + 'px', width: this.setNewWidth() + 'px' }
                    : { height: this.containerHeight + 'px', 'min-height': this.containerHeight + 'px' };
            },
            cosmoWidth() {
                if (this.$route.name === 'cosmo-tour:start') {
                    return 'width: 80%';
                }
            },
            locale() {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            answerTurtle() {
                if (AVAILABLE_ANSWERS_DIRS.includes(this.locale)) {
                    return require(`../../../assets/images/turtle/${this.locale}/${this.locale}_AnswerTurtle.svg`);
                }
                return require(`../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            phrase() {
                if (AVAILABLE_PHRASES_DIRS.includes(this.locale)) {
                    return require(`../../../assets/images/phrases/${this.locale}/${this.status}/${this.locale}_${
                        this.status
                    }_${this.getRandomInt(1, IMAGES_AMOUNT[this.status])}.png`);
                }
                return require(`../../../assets/images/phrases/ru/${this.status}/ru_${this.status}_${this.getRandomInt(
                    1,
                    IMAGES_AMOUNT[this.status]
                )}.png`);
            },
            turtle() {
                if (this.$route.name === 'cosmo-tour:start') {
                    return require(`../../../assets/images/Cosmo${TURTLE_IMAGES[this.status]}.png`);
                }
                return require(`../../../assets/images/${TURTLE_IMAGES[this.status]}${Math.floor(Math.random() * 3) + 1}.gif`);
            },
        },
        data() {
            return {
                containerHeight: 0,
            };
        },
        methods: {
            getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            setNewHeight() {
                let phraseHeight = this.$refs.phraseContainer ? this.$refs.phraseContainer.clientHeight : 0;
                let turtleHeight = this.$refs.turtleContainer ? this.$refs.turtleContainer.clientHeight : 0;

                this.containerHeight = +phraseHeight + (!this.isMultiplayer && turtleHeight);
            },
            setNewWidth() {
                if (this.$route.name === 'cosmo-tour:start') {
                    if (window.innerWidth <= 1200) {
                        return 240;
                    }
                    if (window.innerWidth <= 1440) {
                        return 370;
                    }
                    return 400;
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .image-container {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        min-height: 290px;
        width: 140px;
        @include media($sm) {
            min-height: 400px;
            width: 175px;
        }
        @include media($xlg) {
            min-height: 600px;
            width: 260px;
        }
    }

    .image-container__phrase {
        position: absolute;
        max-width: 100%;
        @media screen and (min-width: 360px) {
            max-width: 120%;
        }
        @include media($xlg) {
            max-width: 70%;
        }
        @include media($xxl) {
            max-width: 80%;
        }
    }

    .image-container__phrase--with-gap {
        top: 10px;
        left: 0;
        @include media($sm) {
            top: 40px;
        }
        @include media($xlg) {
            max-width: 100%;
            top: 0;
        }
    }

    .image-container__turtle {
        position: absolute;
        bottom: 0;
        left: 0;
        max-width: 100%;
        @include media($sm) {
            max-width: 80%;
        }
        @include media($md) {
            max-width: 100%;
        }
        @include media($xlg) {
            height: 400px;
            max-width: 100%;
        }
    }

    .play-box__image_is-multiplayer .image-container__phrase {
        height: 140px;
        @media screen and (max-width: 1439px) {
            height: 100px;
        }
    }
</style>
